import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Logo85Mint from "../../../assets/bob_logo_85_mint.svg";
import Logo85 from "../../../assets/bob_logo_85_purple.svg";
import Logo from "../assets/bob_logo_desktop.svg";
import LogoFooter from "../assets/bob_logo_footer_desktop.svg";
import LogoFooterMobile from "../assets/bob_logo_footer_mobile.svg";
import Image from "../Image";
import "./logoContainer.scss";

export const LOGO_FOOTER = "LOGO_FOOTER";
export const LOGO_FOOTER_MOBILE = "LOGO_FOOTER_MOBILE";

const currentYear = new Date().getFullYear();

let overrideLogo = Logo;
let overrideFooterLogo = LogoFooter;
let overrideFooterMobileLogo = LogoFooterMobile;

export const getLogo = logoType => {
  if (currentYear === 2026) {
    overrideLogo = Logo85;
    overrideFooterLogo = Logo85Mint;
    overrideFooterMobileLogo = Logo85Mint;
  }

  switch (logoType) {
    case LOGO_FOOTER:
      return overrideFooterLogo;
    case LOGO_FOOTER_MOBILE:
      return overrideFooterMobileLogo;
    default:
      return overrideLogo;
  }
};

class LogoContainer extends React.Component {
  render() {
    const { className, onClick, logoType, ...rest } = this.props;
    const logo = getLogo(logoType);
    const image = { webp: logo, fallback: logo, alt: "BOB hjemmeside" };

    return (
      <div className={classnames("bwl-logo-container", className)} onClick={onClick} {...rest}>
        <Image image={image} />
      </div>
    );
  }
}

LogoContainer.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  logoType: PropTypes.string,
};

export default LogoContainer;
